import {MuWidget} from "mu-widget/lib/MuWidget";
import {UiApp} from "./components/front/UiApp";

export class BasePanelWidget extends MuWidget {

    // @ts-ignore
    muParent: UiApp;

    protected setTitle(title: string) {
        this.muParent.ui.panelTitle.textContent = title;
    }

    async closeMe() {
        return this.muParent.closePanel();
    }

    public loader(state: boolean) {
        this.container.classList.toggle('overlay-loader', state);
    }

}